<div class="my-bookings-page">
  <div class="booking-page-wrapper">
    <div class="booking-details">

      <div class="my-bookings-header">
        <!-- <h1 class="heading-1 heading">MY BOOKINGS</h1> -->
        <div class="tabs"><app-tabs *ngIf="showHeaderSection" (tabChangeCallback)="onTabChange($event)" [tabs]="tabDetails" [initialState]="tabValue"></app-tabs></div>
        <div class="flex-placeholder-elt"></div>
      </div>
    
        <div class="bookings-list">
          <app-loader *ngIf="isLoading"></app-loader>
          <app-my-booking-skeleton *ngIf="isLoading; else pageLoad"></app-my-booking-skeleton>
          <ng-template #pageLoad>
            <div class="search-filter-container" *ngIf="showHeaderSection">
              <!-- <div class="select-input-wrapper input-wrapper booking-search"> -->
               <!--  <input class="select-input has-suffix"
                  placeholder="Search using Booking ID,  email ID etc…"
                  [(ngModel)]="searchInput"
                  (keyup)="onSearchInputChange($event)"
                />
                <img src="assets/search.svg" class="input-icon suffix"/> -->
           <div class="search-my-booking">
             <mis-input type="rounded" placeholder="Search">
                <span mis-input-icon><img src="/assets/images/search.svg" alt="" /></span>
                <input type="text" [(ngModel)]="searchInput"
                (keyup)="onSearchInputChange($event)" misInput placeholder="Start typing..." />
              </mis-input>
            </div>
      
              <app-mis-datepicker class="date-position my-booking-date-range-width" [singleDateEnabled]="false" [config]="dateMaxConfig"
              (selectedDate)="selectedDate($event)"></app-mis-datepicker>
            <!-- </div> -->
            <!--   <div *ngIf="tabValue === 'past'" class="date-container">
                <div class="date-filter-wrapper">
                  <div class="start-date-wrapper mr-30">
                    <label class="form-label mr-10">Start Date</label>
                    <app-date-picker *ngIf="inputControlStartDate" [config]="config" [formControl]="inputControlStartDate" (changeCallback)="onStartDateChange($event)"></app-date-picker>
                  </div>
                  <div class="end-date-wrapper">
                    <label class="form-label mr-10">End Date</label>
                    <app-date-picker *ngIf="inputControlEndDate" [config]="config" [formControl]="inputControlEndDate" (changeCallback)="onEndDateChange($event)"></app-date-picker>
                  </div>
                </div>
                <div class="invalid-date" *ngIf="displayInvalidDateError">Invalid date range</div>
              </div> -->
           <!--    <div *ngIf="tabValue === 'upcoming'" class="date-container">
                <div class="date-filter-wrapper">
                  <div class="start-date-wrapper mr-30">
                    <label class="form-label mr-10">Start Date</label>
                    <app-date-picker *ngIf="inputControlStartDate" [config]="config" [formControl]="inputControlStartDate" (changeCallback)="onStartDateChange($event)"></app-date-picker>
                  </div>
                  <div class="end-date-wrapper">
                    <label class="form-label mr-10">End Date</label>
                    <app-date-picker *ngIf="inputControlEndDate" [config]="config" [formControl]="inputControlEndDate" (changeCallback)="onEndDateChange($event)"></app-date-picker>
                  </div>
                </div>
                <div class="invalid-date-my-bookings" *ngIf="displayInvalidDateError">Invalid date range</div>
              </div> -->
      
            </div>
            <div class="bookings-wrapper">
              <div *ngIf="bookings && !bookings.length" class="no-bookings-view">
                <img src="assets/bookings-empty-list.svg" class="no-bookings-img"/>
                <p class="no-bookings-text">You have no bookings</p>
              </div>
              <ng-container *ngIf="bookings && bookings.length && cancelCutOffDetails && editCutOffDetails">
                <!-- *ngFor="let booking of bookings" -->
                <app-my-bookings-card
                  (showBookingsCallback)="handleShowBookings($event)"
                  (showRequestDetailsCallback)="handleShowRequestDetails($event)"
                  (cancelBookingCallback)="toggleCancelConfirmDialog($event)"
                  (showHistoryCallback)="handleShowHistoryView($event)"
                  (showPaginationCallback)="showPaginationCallback($event)"
                  [cancelCutOffDetails]="cancelCutOffDetails"
                  [editCutOffDetails]="editCutOffDetails"
                  [miscelleneousConfig]="miscellConfig"
                  [tabValue]="tabValue"
                  [bookings]="filteredBookings"
                  [currentPageSize] = "currentPageSize"
                  [pageIndexNew] = "pageIndexNew"
                  [totalNoOfRows]="totalNoOfRows"
                  [upcomingOnly]="upcomingOnly"
                  [bookingLabel]="bookingLabel"
                  [paginationId]="paginationId"
                  (refreshBookings)="getBookings()"
                  >
                </app-my-bookings-card>
              </ng-container>
            </div>
          </ng-template>
          <ng-container *ngIf="showPagination">
            <app-pagination 
            *ngIf="totalNoOfRows"
            [totalNoOfRows]="totalNoOfRows"
            [currentPageSize]="currentPageSize"
            [pageIndex]="pageIndexNew"
            (changePage)="pageChangedNew($event)"
            (changeTableSize)= "showNumberOfRecords($event)"
            [paginationId]="paginationId"
        ></app-pagination>
        <!--       <app-pagination *ngIf="totalPages > 0"
            [currentPage]="currentPage+1"
            [totalPages]="totalPages"
            [range]="7"
            (changePage)="pageChanged($event)"
          ></app-pagination> -->
          </ng-container>
        </div>
    </div>
    <div *ngIf="miscellConfig?.enableBookingInstructions" class="booking-instructionwrapper">
      <app-booking-instruction [flow]="'myBookings'" [configComplete]="configComplete"></app-booking-instruction>
    </div>
  </div>

  <app-popover *ngIf="showRequestDetails && requestDetails" (closeCallback)="handleCloseRequestDetails()" size="full">
    <div popover-header>
      <div class="booking-details-header">
        Request ID {{requestDetails[0].requestId}}
      </div>
    </div>
    <div popover-content>
      <app-requester-details [requester]="requestDetails[0].requester" [paymentType]="requestDetails[0].paymentType" [configComplete]="configComplete"></app-requester-details>
      <app-payee-details *ngIf = "requestDetails[0].paymentType === 'Bill To User' && requestDetails[0].payer" [payee] = "requestDetails[0].payer" [paymentType]="requestDetails[0].paymentType"></app-payee-details>  
      <div *ngFor="let booking of requestDetails">
        <app-booking-details [booking]="booking" showBookingId=true></app-booking-details>
      </div>
    </div>
  </app-popover>
  <app-popover *ngIf="showBookingDetails && bookingDetails" (closeCallback)="handleCloseBookingDetails()" size="full">
    <div popover-header>
      <div class="booking-details-header">
        BOOKING ID {{bookingDetails.bookingId}}
      </div>
    </div>
    <div popover-content>
      <app-requester-details [requester]="bookingDetails.requester" [paymentType]="bookingDetails.paymentType" [configComplete]="configComplete"></app-requester-details>
      <app-payee-details *ngIf = "bookingDetails.paymentType === 'Bill To User' && bookingDetails.payer" [payee]="bookingDetails.payer" [paymentType]="bookingDetails.paymentType"></app-payee-details>  
      <app-booking-details [booking]="bookingDetails"></app-booking-details>
    </div>
  </app-popover>
  <app-bookings-history
    *ngIf="showHistoryView"
    [bookingId]="bookingHistoryId"
    [miscelleneousConfig]="miscellConfig"
    (toggleLoadingCallBack)="toggleLoading($event)"
    (handleCloseHistoryCallback)="handleCloseHistoryView()"
  >
  </app-bookings-history>
  <!-- [buttonText]="['View']" -->
  <app-toast *ngIf="bookingsToastMessage" [message]="bookingsToastMessage" (actionCallback)="toastCallback($event)" (dismissCallback)="toggleToast()">
  </app-toast>
  <app-cancel-booking-popover
    *ngIf="showCancelConfirmDialog"
    title="Cancel Booking"
    confirmationText="Are you sure you want to cancel this booking"
    [bookingOrRequestId]="cancelBookingId"
    [cancelPopupConfig]="cancelPopUpConfig.elementConfigList[0]"
    (approveCallback)="handleCancelBooking($event)"
    (dismissCallback)="dismissCancelBookingDialog()"
  ></app-cancel-booking-popover>
</div>
